<template>
  <div id="map"></div>
</template>

<script>
import moment from "moment";
import { loadModules } from "esri-loader";

export default {
  data() {
    return {
      v: 2,
      k: "f534bb6699234c8ab36061a4ea5b0058",
      view: null,
    };
  },
  methods: {},
  mounted() {
    var id = this.$route.params.id;
    console.log(id);

    this.$http
      .post(this.$store.state.base_url + "/navi/r", { shipid: id })
      .then((res) => {
        if (res.data.status == 1) {
          var path_points = [];
          res.data.data.forEach((n) => {
            path_points.push([n.lon / 1000000, n.lat / 1000000]);
          });
          var last_point = path_points[0];
          var point_to_draw = [];
          var date_to_display = [];
          point_to_draw = path_points;
          date_to_display = res.data.data;
          // for (var i = 0; i < path_points.length; i++) {
          //   for (var j = i; j < path_points.length; j++) {
          //     var dist = Math.sqrt(
          //       (path_points[i][0] - path_points[j][0]) ** 2 +
          //         (path_points[i][1] - path_points[j][1]) ** 2
          //     );
          //     if (dist > 0.00001) {
          //       point_to_draw.push(path_points[j]);
          //       date_to_display.push(res.data.data[j]);
          //       i = j;
          //       break;
          //     }
          //   }
          // }
          // console.log(date_to_display);

          loadModules(
            [
              "esri/Map",
              "esri/views/MapView",
              "esri/Basemap",
              "esri/layers/VectorTileLayer",
              "esri/Graphic",
              "esri/geometry/Polyline",
              "esri/geometry/Point",
            ],
            { css: true }
          ).then(
            ([
              ArcGISMap,
              MapView,
              Basemap,
              VectorTileLayer,
              Graphic,
              Polyline,
              Point,
            ]) => {
              // base map , map view and popup
              var basemap = new Basemap({
                baseLayers: [
                  new VectorTileLayer({
                    portalItem: {
                      id: "8dbd7334452c40ec82bb2623d06d0cbf",
                    },
                  }),
                ],
              });
              var map = new ArcGISMap({
                basemap: basemap,
              });
              this.view = new MapView({
                container: this.$el,
                map: map,
                center: point_to_draw[point_to_draw.length - 1],
                zoom: 6,
              });

              // pop up card
              var attributes = {
                Name: "I am a point",
                Park: "Griffith Park",
                City: "Los Angeles",
              };
              var popupTemplate = {
                title: "{Name}",
                content: "I live in <b>{Park}</b> in the city of <b>{City}</b>.",
              };

              // Ship position and symbol
              var pictureGraphic = new Graphic({
                geometry: {
                  type: "point",
                  x: point_to_draw[point_to_draw.length - 1][0],
                  y: point_to_draw[point_to_draw.length - 1][1],
                },
                symbol: {
                  type: "picture-marker",
                  url: "vsl.png",
                  width: "40px",
                  height: "40px",
                },
                attributes: attributes,
                popupTemplate: popupTemplate,
              });
              this.view.graphics.add(pictureGraphic);

              // line
              var polylineGraphic = new Graphic({
                geometry: new Polyline({
                  paths: point_to_draw,
                }),
                symbol: {
                  type: "simple-line",
                  color: [226, 119, 40], // orange
                  width: 1,
                },
              });
              this.view.graphics.add(polylineGraphic);

              // add date and point
              date_to_display.forEach((d) => {
                // date symbol
                var point = new Point({
                  longitude: d.lon / 1000000,
                  latitude: d.lat / 1000000,
                });
                var textSymbol = {
                  type: "text", // autocasts as new TextSymbol()
                  color: "white",
                  haloColor: "black",
                  haloSize: "1px",
                  text: d.lasttime,
                };
                var pointGraphic = new Graphic({
                  geometry: point,
                  symbol: textSymbol,
                });
                //date point
                var markerSymbol = {
                  type: "simple-marker",
                  color: [0, 0, 0],
                  size: 5,
                };
                point = new Graphic({
                  geometry: point,
                  symbol: markerSymbol,
                });
                this.view.graphics.add(point);
                this.view.graphics.add(pointGraphic);
              });
            }
          );
        }
      });
  },
  beforeDestroy() {
    if (this.view) {
      this.view.container = null;
    }
  },
};
</script>
<style scoped>
@import url("https://js.arcgis.com/3.24/esri/css/esri.css");
#map {
  position: absolute;
  top: 20px;
  bottom: 20px;
  left: 16px;
  right: 16px;
}
</style>
